import SidebarLayout from "./SidebarLayout";

const AdminLayout = ({ children }) => {
  return (
    <>
      <div className="wrapper">
        <SidebarLayout />
        {children}
      </div>
    </>
  );
};
export default AdminLayout;
